<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

import axios from 'axios'; 

import DataTable from 'datatables.net-vue3';

export default {
  page: {
    title: "Starter",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
        role:localStorage.getItem('role'),
      title: "Pending Payment",
      items: [
        {
          text: "Order",
          href: "/",
        },
        {
          text: "Pending Payment",
          active: true,
        },
      ],

      isLoadingToDisplayData:true,


        //table
            orderlist:[],
            fields: ['user','Company','Quotation_Number','PO_Number','OrderId','totalQuotation','Action'],

        //end of table
    };
  },

    methods: {

        //api to server
        getList() {
            this.isLoadingToDisplayData=true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'order/pendingpayment')
			.then(response => {

				if (response) {
                    // console.log(response.data);
                    this.orderlist = response.data;
                    // console.log(this.orderlist);
                    this.isLoadingToDisplayData=false;
                } else {
                    this.messageBag = ['No record.'];
                    this.isLoadingToDisplayData=false;
                }
			})
                .catch(error => {
                    this.messageBag = [error.error];
                    this.isLoadingToDisplayData=false;
			});
            
		},

        GetDetailPendingPayment(OrderID){
            this.$router.push('/order/pendingpayment/'+OrderID); 
        }
    },

    mounted() {
        this.getList();
	},

  components: {
    Layout,
    PageHeader,
    DataTable,
  },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header align-items-center d-flex">
                        <h4 class="card-title mb-0 flex-grow-1">Pending Payment</h4>
                    </div>

                    <div class="card-body">
                        <div class="live-preview">
                            <div class="row align-items-center g-12">
                                <br>
                                <div class="col-lg-12">
                                    <div class="table-responsive table-card">
                                        <div v-if='isLoadingToDisplayData'>
                                            <div class="spinner-border text-success" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <DataTable class="table align-middle table-nowrap mb-0">
                                                <thead >
                                                    <tr>
                                                        <th scope="col">NO.</th>
                                                        <th scope="col">COMPANY NAME</th>
                                                        <th scope="col">PERSON IN CHARGE</th>
                                                        <th scope="col">QUOTATION NUMBER</th>
                                                        <th scope="col">PO NUMBER</th>
                                                        <th scope="col">ORDER NO</th>
                                                        <th scope="col">TOTAL PO</th>
                                                        <th scope="col">ACTION</th>
                                                    </tr>
                                                </thead>
                                                <!-- <template #head(user)>{{ "Person In Charge" }}</template> -->

                                                <!-- <template v-slot:cell(totalQuotation)="row">
                                                    MYR {{ row.item.totalQuotation }}
                                                </template>

                                                <template v-slot:cell(Action)="row">
                                                    <i @click="GetDetailPendingPayment(row.item.id)" class="ri-eye-line" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg"></i>
                                                </template> -->
                                                <tbody>
                                                    <tr v-for="(item, index) in orderlist" :key="index" class="content">
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{ item.Company }}</td>
                                                        <td>{{ item.user }}</td>
                                                        <td>{{ item.Quotation_Number }}</td>
                                                        <td>{{ item.PO_Number }}</td>
                                                        <td>{{ item.OrderId}}</td>
                                                        <td>{{ item.currency}} {{ item.totalQuotation }}</td>
                                                        <td> 
                                                            <i @click="GetDetailPendingPayment(item.id)" class="ri-eye-line" style="cursor: pointer;"></i> 
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </DataTable>
                                            <br><br><br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>